module.exports = __webpack_public_path__ + "static/media/img12.328c5f81.jpg";